import { SET_USER } from '../actions'

export default function userReducer(state = null, action) {
  if (action.type === SET_USER) {
    return action.user
  }

  return state
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/user.js